var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalbuiltArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5905_88901",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5905_88901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 14V2H7.9987V4.66667H14.6654V14H1.33203ZM2.66536 12.6667H3.9987V11.3333H2.66536V12.6667ZM2.66536 10H3.9987V8.66667H2.66536V10ZM2.66536 7.33333H3.9987V6H2.66536V7.33333ZM2.66536 4.66667H3.9987V3.33333H2.66536V4.66667ZM5.33203 12.6667H6.66536V11.3333H5.33203V12.6667ZM5.33203 10H6.66536V8.66667H5.33203V10ZM5.33203 7.33333H6.66536V6H5.33203V7.33333ZM5.33203 4.66667H6.66536V3.33333H5.33203V4.66667ZM7.9987 12.6667H13.332V6H7.9987V7.33333H9.33203V8.66667H7.9987V10H9.33203V11.3333H7.9987V12.6667ZM10.6654 8.66667V7.33333H11.9987V8.66667H10.6654ZM10.6654 11.3333V10H11.9987V11.3333H10.6654Z",
    fill: "#343745"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalbuiltArea);
export default __webpack_public_path__ + "static/media/totalbuilt-area.ad715b0ec7b749f27232e68056274fbb.svg";
export { ForwardRef as ReactComponent };